export default __webpack_public_path__ + "static/media/09.30479834.png";